import { render, staticRenderFns } from "./CombinedKnowledge.vue?vue&type=template&id=458a73ba&"
import script from "./CombinedKnowledge.vue?vue&type=script&lang=ts&"
export * from "./CombinedKnowledge.vue?vue&type=script&lang=ts&"
import style0 from "./CombinedKnowledge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports